import {
  prepareCartItemObject,
  prepareOrderItemObject,
  prepareOrderObject,
} from './ecomail-utils';

/**
 * @param order - Order object used in eshop-api
 * @param shopId - The shop ID
 */
export function ecomailPurchase(order: any, shopId: string) {
  ecoAddTransaction(prepareOrderObject(order, shopId));

  order.items.forEach(item => {
    if (!item.ordernr) {
      return;
    }
    ecoAddItem(prepareOrderItemObject(item, order.order_nr));
  });

  ecoTrackTransaction();
}

/**
 * @param cart - Cart object used in eshop-api
 * @param imageUrl - The base URL for the product images
 * @param productUrl - The base URL for the product
 */
export function ecoTrackCart(cart: any, imageUrl, productUrl) {
  if (window.ecotrack) {
    const products = cart
      ? cart.items.map(item =>
          prepareCartItemObject(item, imageUrl, productUrl),
        )
      : [];

    const event = {
      schema: '',
      data: {
        action: 'Basket',
        products,
      },
    };

    window.ecotrack('trackUnstructEvent', event);
  }
}

function ecoAddTransaction(order: any) {
  if (window.ecotrack) {
    window.ecotrack(
      'addTrans',
      order.order_nr,
      order.shopId,
      order.order_tprice,
      order.delivery_price,
      order.payment_price,
      order.delivery_addr_city,
      order.delivery_addr_country,
    );
  }
}

function ecoAddItem(item) {
  if (window.ecotrack) {
    window.ecotrack(
      'addItem',
      item.order_nr,
      item.product_id,
      item.product_name,
      item.categoryPathString,
      item.unitprice,
      item.quantity,
    );
  }
}

function ecoTrackTransaction() {
  if (window.ecotrack) {
    window.ecotrack('trackTrans');
  }
}
